import { render, staticRenderFns } from "./PuzzleNumberSquareCreate.vue?vue&type=template&id=57cb7ba3&"
import script from "./PuzzleNumberSquareCreate.vue?vue&type=script&lang=js&"
export * from "./PuzzleNumberSquareCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports